import { SocketHandler, LifeCycle } from '@/assets/javascript/mixins/Mixins'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AlarmStatus from '@/components/elements/AlarmStatus.vue'
import AlertHandlerList from '@/components/combinations/AlertHandlerList'
export var ServiceAlarm = {
  name: 'NoNameServiceAlarm',
  components: {
    'alarm-status': AlarmStatus,
    'alert-handler-list': AlertHandlerList,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle],
  props: {
    alarm: {
      type: Object,
      default: function () {
        return {
          id: 1,
          label: 'label',
          urgency: 2,
          active: '1574130120000',
          passive: '',
          activeDT: 'Nov 19th 2019, 2:22 AM',
          passiveDT: null,
          state: 'yellow',
          handler: 'service-station-alarm',
          seen: false,
          fixed: false
        }
      }
    },
    alarmData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    store: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    computedAlarmIsActive() {
      if (this.alarm && this.alarm.id !== undefined) {
        return isNaN(this.alarm.passive)
      } else {
        console.warn('no alarms object for', this.$options.name)
        return false
      }
    }
  }
}